import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../App";

const PrivateRoute = ({ children, requiredRole = null }) => {
  const { user } = useAuth();

  // Check if user is logged in
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Check if specific role is required
  if (requiredRole) {
    if (requiredRole === "super_admin" && user.role !== "super_admin") {
      return (
        <div className="container mt-5">
          <div className="alert alert-danger text-center">
            <i className="fas fa-exclamation-triangle fa-3x mb-3"></i>
            <h4>ไม่มีสิทธิ์เข้าถึง</h4>
            <p>คุณต้องเป็น Super Admin เท่านั้นจึงจะเข้าถึงหน้านี้ได้</p>
            <a href="/admin/dashboard" className="btn btn-primary mt-3">
              <i className="fas fa-arrow-left"></i> กลับไปยังแดชบอร์ด
            </a>
          </div>
        </div>
      );
    }

    if (
      requiredRole === "admin" &&
      user.role !== "admin" &&
      user.role !== "super_admin"
    ) {
      return (
        <div className="container mt-5">
          <div className="alert alert-danger text-center">
            <i className="fas fa-exclamation-triangle fa-3x mb-3"></i>
            <h4>ไม่มีสิทธิ์เข้าถึง</h4>
            <p>คุณต้องเป็นผู้ดูแลระบบเท่านั้นจึงจะเข้าถึงหน้านี้ได้</p>
            <a href="/" className="btn btn-primary mt-3">
              <i className="fas fa-arrow-left"></i> กลับไปยังหน้าหลัก
            </a>
          </div>
        </div>
      );
    }
  }

  return children;
};

export default PrivateRoute;
